import React, { useEffect, useState, useRef, isValidElement, createElement } from "react";
import Carousel from "../../classes/Carousel";
import { Link } from 'react-router-dom';
// import leftArrow from '../../assets/images/arrows/arrow-left.svg';
// import rightArrow from '../../assets/images/arrows/arrow-right.svg';
import ArrowIcon from '../icons/utility/ArrowIcon';
import '../../assets/css/carousel/SliderComp.css';

const SliderComp = ({ children, numOfSlides = 3, noButtons = false, containerClass, buttonClass, wrapperClass, bubbles, bubbleContainerClass, bubbleClass, bubbleActiveClass, alignCurrentCenter}) => {
    const carousel = useRef(new Carousel());
    const [content, setContent] = useState(children);

    const [carouselArr, setCarouselArr] = useState([]);
    const [selectedCarousel, setSelectedCarousel] = useState([]);
    const [tempIndex, setTempIndex] = useState(0);

    const getCarousel = () => {
        if(!alignCurrentCenter) {
            carousel.current.getCarousel(setCarouselArr, setSelectedCarousel, false);
        }
        else{
            carousel.current.getCarousel(setCarouselArr, setSelectedCarousel, true);
        }
    }

    useEffect(() => {
        carousel.current.empty();
        if (children.length > 0) {
            children.forEach(c => {
                carousel.current.add(c);
            });

            getCarousel();
        }
    }, [children]);

    useEffect(()=> {
        let tindex;
        if(alignCurrentCenter){
            if(carouselArr.length % 2 === 0) {
                tindex = (carouselArr.length / 2);
            } else {
                tindex = Math.ceil(carouselArr.length / 2) - 1;
            }
    
            setTempIndex(tindex);
        }
        if(!alignCurrentCenter) {
            setTempIndex(0);
        }
    }, [carouselArr]);

    return (
        <div className={" sliderCompContainer flex flexCenter " + (bubbles ? "flexColumn" : "")}>
            <div className={containerClass + " sliderComp-div sliderComp-container"}>
                {/* Left Button */}
                {!noButtons && <button 
                    className={buttonClass + " sliderComp-button flex flexCenter"}
                    onClick={() => {
                        carousel.current.previous();
                        getCarousel();
                    }}
                >
                    {/* <img src={leftArrow} alt="prev Arrow" /> */}
                    <ArrowIcon svgClass="sliderComp-arrow sliderComp-leftArrow" />
                </button>}
                {/* Slider Container */}
                <div className={wrapperClass + " sliderComp-wrapper"}>
                    {carouselArr.map(({ content }, i) => {
                        if (isValidElement(content)) {
                            if (alignCurrentCenter && (((i > tempIndex && i < tempIndex + Math.ceil(numOfSlides/2 )) || (i < tempIndex && i >= tempIndex - Math.floor(numOfSlides/2)) ) || i === tempIndex)) {
                                // console.log(content)
                                return createElement(
                                    content.type,
                                    {
                                        ...content.props,
                                        key: content.key || indexedDB,
                                        className: `${content.props.className || ""}`.trim(),
                                        style: {width: `calc(100% / ${numOfSlides})`}
                                    },
                                    content.props.children
                                );
                            } else if (!alignCurrentCenter &&  ((i > tempIndex && i < tempIndex + numOfSlides) || i === tempIndex)){
                                return createElement(
                                    content.type,
                                    {
                                        ...content.props,
                                        key: content.key || indexedDB,
                                        className: `${content.props.className || ""}`.trim(),
                                        style: {maxWidth: `calc(100% / ${numOfSlides})`}
                                    },
                                    content.props.children
                                );
                            }               
                        }
                        return null;
                    })}
                </div>
                {/* Right Button */}
                {!noButtons && <button 
                    className={buttonClass + " sliderComp-button flex flexCenter"}
                    onClick={() => {
                        carousel.current.next();
                        getCarousel();
                    }}
                >
                    {/* <img src={rightArrow} alt="next Arrow" /> */}
                    <ArrowIcon svgClass="sliderComp-arrow sliderComp-rightArrow" />
                </button>}
            </div>
            {
                bubbles &&
                    <div className={bubbleContainerClass + " sliderComp-bubblesContainer flex flexCenter"}>
                        {carouselArr.map((node, position) => (
                            <div className={bubbleClass + " sliderComp-bubble " + ((selectedCarousel.position === position+1) ? bubbleActiveClass+" sliderComp-bubbleActive" : "")} onClick={() => {
                                carousel.current.shiftTo(position+1);
                                getCarousel();
                            }}></div>
                        ))}
                    </div>
            }
        </div>
    )
}

export default SliderComp;